import { apiClient } from '../client';
import type { components } from '../schema.gen';

export type StrategyInfo = components['schemas']['StrategyInfo'];
export type StrategyParam = components['schemas']['StrategyParam'];

export async function getStrategies(): Promise<StrategyInfo[]> {
  const { data } = await apiClient.get<StrategyInfo[]>('/api/v1/strategies');
  return data;
}

export async function getStrategySchema(type: string): Promise<StrategyInfo> {
  const { data } = await apiClient.get<StrategyInfo>(`/api/v1/strategies/${type}/schema`);
  return data;
}
